import * as React from 'react';
import DP from "./DialogProvider";
import { Menu } from "../../pages/Menu/Menu";

export function SHOW_MENU_DIALOG(section: "hypes" | "actors-and-directors", locale: any) {
    DP.show((res, rej) => {
        return (
            <Menu
                section={section}
                locale={locale}
                onItemClick={() => DP.hide()} />
        )
    }, {
        wrapHeight: "full-height",
        wrapWidth: 'full-width',
        animateIn: "animate__slideInLeft",
        animateOut: "animate__slideOutLeft"
    })
}

export function SHOW_INFO_DIALOG() {
    DP.show((res, rej) => {
        return (
            <h2>div</h2>
        )
    }, {
        wrapHeight: "full-height",
        wrapWidth: 'full-width'
    })
}
